export default {"src":"/_next/static/media/star.4fe9be34.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};